import { AnyAction } from "redux";
import { cloneDeep } from "lodash";
import { HANDLEACTIVE } from "../actions/medicalRecord";

interface IMedicalRecordReducer {
  abaActive: number | 1;
}

const initialState: IMedicalRecordReducer = {
  abaActive: 1,
};

export const MedicalRecordReducer = (
  state = initialState,
  action: AnyAction
) => {
  switch (action.type) {
    case HANDLEACTIVE: {
      return {
        ...cloneDeep(state),
        abaActive: action.aba,
      };
    }
    default: {
      return state;
    }
  }
};
